module.exports = __webpack_public_path__ + "media/images/icons/icons_small/55_shampagneBottle-e84c919fc65c34d6027fcabb6106c40e.png";